import moment from 'moment'

const TextHelper = {
  install (Vue, options) {
    Vue.prototype.$textHelper = {
      capitalizeFirstLetter (text, removeUnderScore = false) {
        let txt = text
        if (removeUnderScore) {
          txt = this.underscoreToSpace(txt)
        }
        return txt.charAt(0).toUpperCase() + txt.slice(1)
      },
      underscoreToSpace (text) {
        return text.split('_').join(' ')
      },
      toThaiDate (date) {
        const month = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
        let str = `${moment(date).format('D')}`
        str += ` ${month[moment(date).format('M') - 1]} `
        str += ` พ.ศ. ${parseInt(moment(date).format('YYYY')) + 543}`
        return str
      }
    }
  }
}

export default TextHelper



// WEBPACK FOOTER //
// ./src/helpers/TextHelper.js